import { render, staticRenderFns } from "./WelcomeFirstScreen.vue?vue&type=template&id=a4d4a70e&"
import script from "./WelcomeFirstScreen.vue?vue&type=script&lang=js&"
export * from "./WelcomeFirstScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports